exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-input{border-radius:4px;border:1px solid #001d38;padding:14px}#card-name-errors{color:#b71c1c}.StripeElement{border-color:#9b9b9b!important}.my-input-name{border-radius:4px;padding:11.5px 17px;color:#000;border:1px solid #9b9b9b}.my-input-name ::-moz-placeholder{font-size:1em}.my-input-name :-ms-input-placeholder{font-size:1em}.my-input-name ::placeholder{font-size:1em}", ""]);

// exports
